import axios from "axios";

// const modelsHeader = {
//     'Content-Type': 'application/json',
//     'AccessToken': process.env.VUE_APP_MODELSTOKEN,
// }

const state = () => ({
    engines: [],
    hasEngines: false,
});

const getters = {
    getEngines: state => id => {
        let res = state.engines.filter(el => el.modelID == id)

        res.sort((prev, curr) => {
            let a = prev.price
            let b = curr.price

            return parseFloat(a) > parseFloat(b) ? 1 : -1
        })

        return res
    },
    modelHasEngine: state => id => {
        if(!id) return false
        let res = state.engines.some(el => el.modelID == id)
        return res ? true : false
    },
    getEngineById: state => id => {
        let co2 = 0
        let fuelCC = 0
        let res = state.engines.find(el => el.id == id)?.lst
        if(res) res.forEach(el => {
            if(el.id == 284) co2 = el.specs.value
            if(el.id == 289) fuelCC = el.specs.value
        })
        return { co2: co2, fuelCC: fuelCC}
    },
    getFullEngineByID: state => id => {
        let res = state.engines.find(el => el.id == id)
        return res
    }
};

const mutations = {
    SET_ENGINES(state, payload){
        payload.forEach(engine => {
            let bool = state.engines.some(el => el.modelID == engine.id)
            if(!bool) state.engines.push(engine)
        });
        state.hasEngines = true
    }
};

const actions = {
    fetchEngines({ commit, getters }, id){
        if(getters.modelHasEngine(id)) return

        const hyu = process.env.VUE_APP_HYU
        let url = hyu + process.env.VUE_APP_API_ENGINES + id;

        // axios.get(url, { headers: modelsHeader})
        axios.get(url)
        .then( res => commit('SET_ENGINES', res.data))
        .catch( err => console.log(err))
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
